// import React from "react";
import React, { useState } from 'react'
import { Container, HeaderContent } from './styles'


export function Header() {
    const [toggle, setToggle] = useState(false);
    const [activeNavMenu, setActiveNavMenu] = useState('#home');

    return (
        <HeaderContent>
            <Container>
                <nav>
                    <a href="/"> Jonas Borges </a>

                    <div className={toggle ? "show-menu" : ""}>
                        <ul>
                            <li>
                                <a 
                                    href="#home" 
                                    onClick={()=>{setActiveNavMenu('#home')}}
                                    className={activeNavMenu === '#home' ? "navMenu-active" : ""}
                                    >
                                    <i className="uil uil-estate"></i>
                                    Home
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="#about"
                                    onClick={()=>{setActiveNavMenu('#about')}}
                                    className={activeNavMenu === '#about' ? "navMenu-active" : ""}
                                    >
                                    <i className="uil uil-user"></i>
                                    Sobre
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="#skills"
                                    onClick={()=>{setActiveNavMenu('#skills')}}
                                    className={activeNavMenu === '#skills' ? "navMenu-active" : ""}
                                >
                                    <i className="uil uil-file-alt"></i>
                                    SkiLls
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="#portfolio"
                                    onClick={()=>{setActiveNavMenu('#portfolio')}}
                                    className={activeNavMenu === '#portfolio' ? "navMenu-active" : ""}
                                >
                                    <i className="uil uil-scenery"></i>
                                    Portfolio
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="#testimonials"
                                    onClick={()=>{setActiveNavMenu('#testimonials')}}
                                    className={activeNavMenu === '#testimonials' ? "navMenu-active" : ""}
                                >
                                    <i className="uil uil-comment-notes"></i>
                                    Depoimentos
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="#contact"
                                    onClick={()=>{setActiveNavMenu('#contact')}}
                                    className={activeNavMenu === '#contact' ? "navMenu-active" : ""}
                                >
                                    <i className="uil uil-message"></i>
                                    Contato
                                </a>
                            </li>
                            <li>
                                <div className='darkmode-toggle'>
                                    <input 
                                        type="checkbox" 
                                        name="darkmode-toggle" 
                                        id="darkmode-toggle" 
                                    />
                                    <label htmlFor="darkmode-toggle">
                                        <i className="uil uil-sun"></i>
                                        <i className="uil uil-moon"></i>
                                    </label>
                                </div>
                            </li>
                        </ul>

                        

                        <i className="uil uil-times nav__close" onClick={()=> setToggle(!toggle)}></i>
                    </div>
                    <div className="nav__toggle" onClick={()=> setToggle(!toggle)}>
                        <i className="uil uil-apps"></i>
                    </div>
                </nav>
            </Container>
        </HeaderContent>
    )
}